import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Card, Image, Label, Button, Icon, Header, Grid } from 'semantic-ui-react';
import _ from 'underscore';
import Color from 'color';

import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import UserUtils from 'utils/UserUtils.js';
import ChallengeUtils from 'utils/ChallengeUtils.js';
import {colors, fontSizes, fonts, spacings, layout, shadow, shadowLight, buttons} from 'style';
import defaultAvatar from 'img/default-avatar.png';
import defaultChallengeImage from 'img/default-challenge-image.jpg';
import {getCompetitionProgressBars} from './tools.js';

var style= {
    content: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '800px',
        lineHeight: '1.5',
        ...fonts.body,
    },
    segment: {
        backgroundColor: 'white',
        borderRadius: '9px',
        boxShadow: shadowLight,
        margin: spacings.small,
        textAlign: 'center',
    },
    title: {
        padding: spacings.base,
        fontSize: fontSizes.h3,
        color: colors.themeBlue,
        textAlign: 'center',
        lineHeight: '2.5',
    },
    h3: {
        fontSize: fontSizes.h3,
        color: colors.themeBlue,
        padding: spacings.base,
    },
    h4: {
        color: colors.themeBlue,
        ...fonts.h4,
    },
    subtitle: {
        marginTop: spacings.small,
        fontSize: fontSizes.bodyL,
        color: colors.themeBlue,
    },
    banner: {
        width: '100%',
        borderTopRightRadius: '9px',
        borderTopLeftRadius: '9px',
    },
    competitionTitle: {
        paddingTop: '0',
        paddingBottom: '0',
    },
    description: {
        padding: spacings.base,
        textAlign: 'left',
    },
    button: {
        ...buttons.long,
    },
    cardContent: {
        padding: spacings.base,
    },
    column: {
        verticalAlign: 'top',
        width: '50%',
        display: 'inline-block',
    },
    fullWidth: {
        width: '100%',
    },
    rewards: {
        textAlign: 'left',
        padding: spacings.base,
        height: '400px',
        marginTop: '0px',
        marginBottom: '0px',
        marginLeft: spacings.tiny,
    },
    fullWidthRewards: {
        marginLeft: spacings.small,
    },
    leaderboard: {
        textAlign: 'left',
        padding: spacings.base,
        height: '400px',
        marginTop: '0px',
        marginBottom: '0px',
        marginRight: spacings.tiny,
    },
    activities: {
        textAlign: 'left',
        padding: spacings.base,
    },
    activitiesTitle: {
        paddingBottom: spacings.base,
    },
    starIcon: {
        marginLeft: spacings.small,
        fontSize: '1em',
        opacity: '1',
        color: colors.pointsYellow,
    },
    resourceIcon: {
        marginLeft: spacings.small,
        fontSize: '1em',
        opacity: '1',
        color: colors.themeBlue,
    },
    avatarWrapper: {
        display: 'inline-block',
        borderRadius: '50%',
        height: '48px',
        verticalAlign: 'middle',
        marginLeft: spacings.tiny,
        marginRight: spacings.tiny,
    },
    avatar: {
        boxShadow: shadow,
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: '#fff',
        borderRadius: '50%',
        height: '48px',
        width: '48px',
        verticalAlign: 'top',
    },
    leaderboardRow: {
        position: 'relative',
        color: colors.themeDarkerGrey,
        marginTop: spacings.tiny,
        marginBottom: spacings.tiny,
    },
    rewardRank: {
        display: 'inline-block',
        width: '20px',
    },
    reward: {
        display: 'inline-block',
        width: '100px',
    },
    rewardsRow: {
        color: colors.themeDarkerGrey,
    },
    personInfo: {
        width: '100%',
        textOverflow: 'ellipsis'
    },
    personalInfoItem: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        color: colors.themeDarkerGrey,
    },
    leaderboardBar: {
        marginTop: '5px',
        height: '10px',
        width: '100%',
        backgroundColor: colors.themeBlue,
        background: 'linear-gradient(to right, '+colors.themeBlue+', '+colors.themeTeal+')',
        borderRadius: '4px',
    },
    recordBarBody: {
        position: 'absolute',
        paddingLeft: '79px',
        paddingRight: '60px',
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100%',
    },
    recordPoints: {
        height: '100%',
        color: colors.pointsYellow,
        fontSize: '1.1em',
        fontWeight: 'normal',
        textAlign: 'left',
        position: 'absolute',
        right: '0px',
        top: '20px',
    },
    completionPrize: {
        fontSize: fontSizes.bodyL,
    },
    rankingBonus: {
        fontSize: fontSizes.bodyL,
    },
    challengeImage: {
        display: 'inline-block',
        verticalAlign: 'top',
        width: '60px',
        height: '60px',
        border: '2px solid #fff',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '6px',
        backgroundColor: '#fff',
        color: colors.themeDarkGrey,
        fontSize: '30px',
        textAlign: 'center',
        lineHeight: '38px',
        boxShadow: shadow,
    },
    activityPackInfoRow: {
        marginTop: '16px',
        verticalAlign: 'top',
        paddingLeft: spacings.base,
        display: 'inline-block',
    },
    activityPackTitle: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        color: colors.themeDarkerGrey,
    },
    activityPackType: {
        color: colors.themeDarkGrey,
    },
    activityPack: {
    },
    activityInfoRow: {
        verticalAlign: 'top',
        paddingLeft: spacings.base,
        display: 'inline-block',
    },
    activityTitle: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        fontWeight: 'bold',
        color: colors.themeDarkerGrey,
    },
    activityType: {
        color: colors.themeDarkGrey,
    },
    activity: {
        cursor: 'pointer',
    },
    progressBar: {
        backgroundColor: Color(colors.pointsYellow).alpha(0.25).toString(),
    },
    progressBarContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '320px',
        padding: spacings.base,
        color: colors.themeBlue,
    },
    seeAll: {
        float: 'right',
        color: colors.themeBlue,
        cursor: 'pointer',
    },
    progressbarWrapper: {
        paddingTop: '4px',
        paddingBottom: '4px',
    }
};

const ranks = {
    1:{color: colors.pointsYellow},
    2:{color: colors.pointsSilver},
    3:{color: colors.pointsBronze},
}
const avatars = {
    1:{borderColor: colors.pointsYellow},
    2:{borderColor: colors.pointsSilver},
    3:{borderColor: colors.pointsBronze},
}

const rankSortFunc = x => {
    var rank = x.rank;
    if(rank === null || rank === undefined) {
        return Number.MAX_VALUE;
    }
    return rank;
}


const Activity = ({t, challenge, onLaunchChallenge}) => (
    <div style={style.activity} onClick={()=>onLaunchChallenge(challenge)}>
        <div style={{...style.challengeImage, backgroundImage:Utils.url(Utils.deref(challenge, 'image.url') || defaultChallengeImage)}} />
        <div style={style.activityInfoRow}>
            <div style={style.activityTitle}>{challenge.title}</div>
            <div style={style.activityType}>{t(ChallengeUtils.Types[challenge.type])}</div>
        </div>
    </div> 
);

const ActivityPack = ({t, category}) => (
    <div style={style.activityPack}>
        <div style={{...style.challengeImage, backgroundImage:Utils.url(Utils.deref(category, 'badge.url') || defaultChallengeImage)}} />
        <div style={style.activityPackInfoRow}>
            <div style={style.activityPackTitle}>{category.title}</div>
        </div>
    </div> 
);

const Competition = ({t,
                busy, 
                card,
                season,
                challenges,
                categories,
                userProfile,
                targetPoints,
                column,
                getName,
                formatLeaderboardValue,
                showCompetitionActivities,
                showLeaderboards,
                onShowCompetitionActivities,
                onLaunchChallenge,
                onLaunchLeaderboard,
                }) => (
    <div style={style.content}>
        {Boolean(!showCompetitionActivities) &&
        <div>
            {Boolean(card && card.season) &&
                <div style={style.title}>{card.season.title}</div>
            }
            {Boolean(card && card.season && card.season.competition) &&
            <div style={style.segment}>
                <img style={style.banner} alt='' src={Utils.deref(card, 'season.competition.banner.url') || defaultChallengeImage} />
                <div style={style.cardContent}>
                    <div style={{...style.h3, ...style.competitionTitle}}>{card.season.competition.title}</div>

                    {Boolean(season) &&
                    <div style={style.progressBarContainer}>
                        {getCompetitionProgressBars(season.userRecord, season.seasonMilestone, t).map(progressbar => 
                            <div key={progressbar.type} style={style.progressbarWrapper}>
                                <ProgressBar style={style.progressBar} value={progressbar.percent} total={100} borderWidth={'0'} />
                                <div>{progressbar.label}</div>
                            </div>
                        )}
                    </div>
                    }

                    <Button style={style.button} onClick={()=>onShowCompetitionActivities(null)}>{card.season.competition.buttonLabel}</Button>
                </div>
            </div>
            }
            {Boolean(card && card.season && card.season.competition) &&
                <div style={{...style.segment, ...style.description}}>
                    <div style={style.h4}>{t('what-to-do')}</div>
                    {card.season.competition.description}
                </div>
            }

            <div>
                {Boolean(showLeaderboards) &&
                <div style={style.column}>

                    <div style={{...style.segment, ...style.leaderboard}}>

                        {Boolean(season && season.leaderboard) &&
                            <div onClick={()=>onLaunchLeaderboard(season.leaderboard.id)} style={style.seeAll}>{t('see-all')}</div>
                        }

                        <div style={style.h4}>
                            {t('leaderboard')}
                        </div>
                        {Boolean(season && season.userRecord && userProfile) &&
                        <div style={style.subtitle}>
                            {t('your-score')}

                            <div style={style.leaderboardRow}>
                                <span style={{...style.rank, ...ranks[season.leaderboard.rank]}}>{season.leaderboard.rank}</span>
                                <div style={style.avatarWrapper}><div style={{...style.avatar, ...(avatars[season.leaderboard.rank]), backgroundImage:Utils.url(Utils.deref(userProfile, 'avatar.url') || defaultAvatar)}} /></div>
                                <div style={style.recordBarBody}>
                                    <div style={style.personInfo}>
                                        <div style={style.personalInfoItem}>{getName(userProfile)}</div>
                                    </div>
                                    <div style={{...style.leaderboardBar, width:(String(Utils.getPercent(season.userRecord[column], targetPoints))+'%')}} />
                                    <div style={style.recordPoints}>{formatLeaderboardValue(season.userRecord, column)}</div>
                                </div>
                            </div>
                        </div>
                        }
                        
                        {Boolean(season && season.leaderboard && season.leaderboard.userRecords) &&
                            <div>
                                <div style={style.subtitle}>
                                     {t('leaders')}
                                </div>
                            {season.leaderboard.userRecords.map((userRecord, i) => 
                                <div key={userRecord.id} style={style.leaderboardRow}>
                                    <span style={{...style.rank, ...ranks[i+1]}}>{i+1}</span>
                                    <div key={i} style={style.avatarWrapper}><div style={{...style.avatar, ...(avatars[i+1]), backgroundImage:Utils.url(Utils.deref(userRecord, 'userProfile.avatar.url') || defaultAvatar)}} /></div>

                                    <div style={style.recordBarBody}>
                                        <div style={style.personInfo}>
                                            <div style={style.personalInfoItem}>{getName(userRecord.userProfile)}</div>
                                        </div>
                                        <div style={{...style.leaderboardBar, width:(String(Utils.getPercent(userRecord[column], targetPoints))+'%')}} />
                                        <div style={style.recordPoints}>{formatLeaderboardValue(userRecord, column)}</div>
                                    </div>

                                </div>
                            )}     
                            </div>
                        }
                    </div>
                
                </div> 
                }

                <div style={{...style.column, ...(!showLeaderboards && style.fullWidth)}}>
                
                    <div style={{...style.segment, ...style.rewards, ...(!showLeaderboards && style.fullWidthRewards)}}>
                        <div style={style.h4}>
                            {t('challenge-rewards')}
                        </div>
                    
                            <div>
                                <div style={style.completionPrize}>
                                    <div style={style.subtitle}>
                                        {t('completion-prize')}
                                    </div>
                                    {Boolean(season) && Boolean(season.seasonMilestone) && <div>
                                        <Icon style={{...style.starIcon, marginLeft: '0px'}} className="notClickable icon-star"/>{season.seasonMilestone.rewardPoints} 
                                        <Icon style={style.resourceIcon} className="notClickable icon-Optimollar"/>{season.seasonMilestone.rewardResources}
                                    </div>|| <em>({t('None')})</em> }
                                </div> 
                                
                                
                                <div style={style.rankingBonus}>
                                    <div style={style.subtitle}>
                                        {t('ranking-bonus')}
                                    </div>
                                    {Boolean(season) && Boolean(season.leaderboard && season.leaderboard.leaderboardRewards && season.leaderboard.leaderboardRewards.length) && _.sortBy(season.leaderboard.leaderboardRewards, rankSortFunc).map(leaderboardReward => (
                                        <div key={leaderboardReward.id} style={style.rewardsRow}>
                                            <span style={{...style.rewardRank, ...ranks[leaderboardReward.rank]}}>#{leaderboardReward.rank || 'X'} </span>
                                            <span style={style.reward}><Icon style={style.starIcon} className="notClickable icon-star"/>{leaderboardReward.rewardPoints}</span>
                                            <span style={style.reward}><Icon style={style.resourceIcon} className="notClickable icon-Optimollar"/>{leaderboardReward.rewardResources}</span>
                                        </div> 
                                    )) || <em>({t('None')})</em> } 
                                </div>
                            </div>
                        
                    </div>
                
                </div> 
            </div>

            {Boolean(categories) &&
            <div style={{...style.segment, ...style.activities}}>

                <div style={{...style.h4, ...style.activitiesTitle}}>
                    {t('activity-packs', {count:categories.length})}
                </div>


                <Grid>
                    {categories.map((category, i) =>
                        Boolean(i%2==0) ? (
                            <Grid.Row columns={2} key={i}>
                              <Grid.Column>
                                <ActivityPack t={t} category={category} />
                              </Grid.Column>
                              {Boolean(categories[i+1]) &&
                              <Grid.Column>
                                <ActivityPack t={t} category={categories[i+1]} />
                              </Grid.Column>
                              }
                            </Grid.Row>
                        ) : null
                    )}
                </Grid>
            </div>
            }
        </div>
        }



        {Boolean(challenges && showCompetitionActivities) &&
        <div>
            {Boolean(card && card.season && card.season.competition) &&
            <div style={style.segment}>
                <div style={style.cardContent}>
                    <div style={{...style.h3, ...style.competitionTitle}}>{card.season.competition.title}</div>

                    {Boolean(season) &&
                    <div style={style.progressBarContainer}>
                        {getCompetitionProgressBars(season.userRecord, season.seasonMilestone, t).map(progressbar => 
                            <div key={progressbar.type} style={style.progressbarWrapper}>
                                <ProgressBar style={style.progressBar} value={progressbar.percent} total={100} borderWidth={'0'} />
                                <div>{progressbar.label}</div>
                            </div>
                        )}
                    </div>
                    }
                </div>
            </div>
            }
            <div style={{...style.segment, ...style.activities}}>
                <Grid>
                    {challenges.map((challenge, i) =>
                        Boolean(i%2==0) ? (
                            <Grid.Row columns={2} key={i}>
                              <Grid.Column>
                                <Activity onLaunchChallenge={onLaunchChallenge} t={t} challenge={challenge} />
                              </Grid.Column>
                              {Boolean(challenges[i+1]) &&
                              <Grid.Column>
                                <Activity onLaunchChallenge={onLaunchChallenge} t={t} challenge={challenges[i+1]} />
                              </Grid.Column>
                              }
                            </Grid.Row>
                        ) : null
                    )}
                </Grid>
            </div>
        </div>
        }
    </div>
)


export default translate('challenges')(Competition);



// WEBPACK FOOTER //
// ./src/modules/challenges/Competition.js